import type { MutableRef } from 'preact/hooks';
import { InputDetail } from '../../utils/UNSAFE_meterTypes';

export const handleInput = (
  inputValue: number | undefined,
  currentInput: MutableRef<number | undefined>,
  onInput?: (detail: InputDetail) => void
) => {
  onInput?.({ value: inputValue } as InputDetail);
  currentInput.current = inputValue;
};

export const cancelEvent = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();
};
